import React from 'react';
import { t } from 'es6/services/localization';
import { NavButton, Navigation } from 'es6/components/apps/navigation';
import SoundManager from 'es6/services/sound-manager';
import { WELCOME } from 'es6/core/sound-effects';

/**
 * Mixin for the other panels.
 */
export const WelcomeSentenceTrainerMixin = {
  propTypes: {
    onMenu: React.PropTypes.func.isRequired,
    onStart: React.PropTypes.func.isRequired,
    sessionData: React.PropTypes.object.isRequired,
  },

  componentDidMount() {
    SoundManager.playEffect(WELCOME);
  },

  _renderNavigation() {
    if (this.props.sessionData.studySession.length === 0) {
      return this._renderEmptyStudyNavigation();
    }

    return (
      <Navigation>
        <NavButton align="left" onClick={this.props.onMenu}>{t('js_iknow.menu')}</NavButton>
        <NavButton align="right" focused onClick={this.props.onStart}>{t('start')}</NavButton>
      </Navigation>
    );
  },

  _renderEmptyStudyNavigation() {
    return (
      <Navigation>
        <NavButton align="left" focused onClick={this.props.onMenu}>{t('js_iknow.menu')}</NavButton>
      </Navigation>
    );
  },

  /**
   * Helper method to render session details for the sentence trainer welcome
   * screens.
   */
  _renderSessionDetails() {
    const sessionData = this.props.sessionData;
    const newCount = sessionData.studySession.filter(s => !s.memory).length;
    const reviewCount = sessionData.studySession.length - newCount;

    return (
      <div className="session-details">
        <h4 className="next-session-header">{t('next-session')}</h4>

        <div className="sentence-counts">
          <div className="sentence-count sentence-count-new">
            <span className="primary">{newCount}</span>
            <span className="secondary">{t('new-sentences')}</span>
          </div>

          <span className="hr-vertical" />

          <div className="sentence-count sentence-count-review">
            <span className="primary">{reviewCount}</span>
            <span className="secondary">{t('review-sentences')}</span>
          </div>
        </div>
      </div>
    );
  },
};

export default WelcomeSentenceTrainerMixin;
